import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs/internal/Subject';
import { Envsetting } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AutofilliaService {

  private dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public readonly data$: Observable<any[]> = this.dataSubject.asObservable();


  private insert_dataSubject = new Subject<any>();
  public readonly insert_data$: Observable<any> = this.insert_dataSubject.asObservable();

  private getIAUser_dataSubject = new Subject<any>();
  public readonly getIAUser_data$: Observable<any> = this.getIAUser_dataSubject.asObservable();
  constructor(private http: HttpClient) { }

  

  SaveRegisterData(insert_obj: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };
    return this.http.post<any>(Envsetting.apiBaseUrl + 'industryassociation/saveuser', insert_obj, httpOptions);
  }

  verifyIAUserCredentials(formDataValue: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };
    return this.http.post<any>(Envsetting.apiBaseUrl + 'industryassociation/login', formDataValue, httpOptions);
  }

  verifyOTP(otpdata: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };
    return this.http.post<any>(Envsetting.apiBaseUrl + 'notification/verifyOtp', otpdata, httpOptions);
  }

  sendOTP(otpdata: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };
    return this.http.post<any>(Envsetting.apiBaseUrl + 'notification/sendOtp', otpdata, httpOptions);
  }

  forgotPassword(passwordData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };
    return this.http.post<any>(Envsetting.apiBaseUrl + 'industryassociation/password/update', passwordData, httpOptions);
  }
  
  getRegisteredIAUserDetails(iaUserID: any): Observable<any> {
    let params = new HttpParams().set('IAUserName', iaUserID);
    return this.http.get(`${Envsetting.apiBaseUrl}industryassociation/getuserbyid`, { params });

    // return this.http.get(Envsetting.apiBaseUrl+'msme/getuserbyudyamno?dtoUdyamNumber='+u_num,u_num); 
  }

}
